import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import PageHeader from "../-components/PageHeader";
import ConsoleHrozontalHeadTable from "../-components/ConsolehorizontalHeadTable";
import LoadingPop from "components/popup/LoadingPop";
import ConfirmDialog from "components/popup/ConfirmDialog";
import Seo from "components/Seo";
import DriverForm, { DriverFormState } from "./DriverForm";
import { useGetConsoleDriverDetail, useDeleteConsoleDriver } from "hooks/console/useConsoleDriver";

export default function ConsoleDriverDetail() {
    const navigate = useNavigate();
    const location = useLocation();
    const idx = useParams().idx ?? "";
    const page = location.state?.page ?? "1";
    const [editMode, setEditMode] = useState(false);
    const { data, isLoading } = useGetConsoleDriverDetail(idx);
    const { mutate: deleteDriver } = useDeleteConsoleDriver(() => navigate(`/morning/customer/driver?page=${page}`));
    const [form, setForm] = useState<DriverFormState>({ driver_no: null, name: "", phone: "", car_no: "" });

    useEffect(() => {
        if (data) {
            setForm({ driver_no: data.driver_no, name: data.name || "", phone: data.phone || "", car_no: data.car_no || "" });
        }
    }, [data]);

    const thead = [
        { title: "기사명", key: "name" },
        { title: "전화번호", key: "phone" },
        { title: "차량번호", key: "car_no" },
    ];

    if (!idx) return <div>잘못된 접근입니다.</div>;

    return (
        <>
            <Seo type="console" pageTitle="기사 관리" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="고객서비스" title="기사 상세" />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className="px-[40px] py-[28px] w-full overflow-auto">
                        {isLoading ? (
                            <LoadingPop />
                        ) : data ? (
                            <div className="bg-white rounded-[20px] py-[36px] px-[40px] w-full min-w-[800px]">
                                {editMode ? (
                                    <DriverForm form={form} setForm={setForm} setEditMode={setEditMode} update />
                                ) : (
                                    <>
                                        <ConsoleHrozontalHeadTable thead={thead} tbody={data} />
                                        <div className="flex justify-center gap-x-[8px] mt-5">
                                            <button
                                                className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                                onClick={() => setEditMode(true)}
                                            >
                                                수정
                                            </button>
                                            <ConfirmDialog
                                                title="기사 삭제"
                                                trigger={open => (
                                                    <button
                                                        type="button"
                                                        onClick={open}
                                                        className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                                    >
                                                        삭제
                                                    </button>
                                                )}
                                                handleConfirm={() => deleteDriver({ driver_no: [Number(idx)] })}
                                            />
                                            <button
                                                onClick={() => navigate(`/morning/customer/driver?page=${page}`)}
                                                className="text-white text-[18px] bg-[#4F46E5] rounded-[5px] border border-[#666666] px-[55px] py-[15px]"
                                            >
                                                목록
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className="bg-white rounded-[20px] flex flex-col gap-5 items-center justify-center py-[100px]">
                                <p>결과가 없습니다.</p>
                                <button onClick={() => navigate(-1)} className="rounded-[8px] border px-5 py-2">
                                    뒤로가기
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
